/* import __COLOCATED_TEMPLATE__ from './unpaired-device-icon.hbs.js'; */
import Component from '@ember/component';
export default class UnpairedDeviceIcon extends Component {}